import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

// Async thunks
export const generateSimilarityMatrix = createAsyncThunk(
  'similarity/generateMatrix',
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/assignment/generate', requestData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to generate similarity matrix')
    }
  }
)

export const generateDemoSimilarityMatrix = createAsyncThunk(
  'similarity/generateDemoMatrix',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.post('/assignment/demo')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to generate demo similarity matrix')
    }
  }
)

export const getSimilarityWeights = createAsyncThunk(
  'similarity/getWeights',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('/assignment/weights')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to get similarity weights')
    }
  }
)

const initialState = {
  similarityMatrix: null,
  professors: [],
  questionPapers: [],
  summaryStats: null,
  weights: null,
  loading: false,
  error: null,
  generatedAt: null
}

const similaritySlice = createSlice({
  name: 'similarity',
  initialState,
  reducers: {
    clearSimilarityData: (state) => {
      state.similarityMatrix = null
      state.professors = []
      state.questionPapers = []
      state.summaryStats = null
      state.generatedAt = null
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Generate similarity matrix
      .addCase(generateSimilarityMatrix.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(generateSimilarityMatrix.fulfilled, (state, action) => {
        state.loading = false
        state.similarityMatrix = action.payload.similarity_matrix
        state.professors = action.payload.professors
        state.questionPapers = action.payload.question_papers
        state.summaryStats = action.payload.summary_stats
        state.generatedAt = action.payload.generated_at
      })
      .addCase(generateSimilarityMatrix.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Generate demo similarity matrix
      .addCase(generateDemoSimilarityMatrix.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(generateDemoSimilarityMatrix.fulfilled, (state, action) => {
        state.loading = false
        state.similarityMatrix = action.payload.similarity_matrix
        state.professors = action.payload.professors
        state.questionPapers = action.payload.question_papers
        state.summaryStats = action.payload.summary_stats
        state.generatedAt = action.payload.generated_at
      })
      .addCase(generateDemoSimilarityMatrix.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // Get similarity weights
      .addCase(getSimilarityWeights.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getSimilarityWeights.fulfilled, (state, action) => {
        state.loading = false
        state.weights = action.payload.weights
      })
      .addCase(getSimilarityWeights.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearSimilarityData, setError, clearError } = similaritySlice.actions
export default similaritySlice.reducer 